import { render } from "./googleComponent.vue?vue&type=template&id=b021f786"
import script from "./googleComponent.vue?vue&type=script&lang=js"
export * from "./googleComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__